export default __webpack_public_path__ + "static/media/Clutch.32effd11.svg";